import '@app/components/ComponentWithSelect/styles/ComponentWithSelect.desktop.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

import type { ComponentWithSelectProps } from '@app/components/ComponentWithSelect/ComponentWithSelect.types';
import { getIconObjectById } from '@app/utils';

import type { IconProp } from '@fortawesome/fontawesome-svg-core';

export const ComponentWithSelect: React.FC<ComponentWithSelectProps> = ({
  children,
  leftIconId,
  selectedOption,
  selectOptions = [],
  menuMarginLeft = 0,
  onSelectOptionClick,
  isExpanded,
  onExpandChange,
}) => {
  const selectedFieldText = selectedOption?.text;

  const { code: customIcon, color: customColor } = getIconObjectById(
    leftIconId,
    {
      color: 'gray',
    }
  ) as { code: IconProp; color: string };

  const { code: selectIcon, color: selectColor } = getIconObjectById(
    'arrows-up-down',
    {
      color: 'black',
    }
  ) as { code: IconProp; color: string };

  return (
    <div className="custom-field-container">
      <div className="custom-icon">
        <FontAwesomeIcon
          icon={customIcon}
          style={{
            color: customColor,
          }}
        />
      </div>

      {children}

      <div className="custom-select no-text-selection" onClick={onExpandChange}>
        <div className="selected-option">
          <span className="selected-option-text">{selectedFieldText}</span>
        </div>

        <div
          className={`options-list ${isExpanded ? 'expanded' : ''}`}
          style={{ marginRight: `${menuMarginLeft * -1}px` }}
        >
          {selectOptions.map((option) => (
            <div
              key={option.id}
              className="option"
              onClick={() => {
                onSelectOptionClick(option);
              }}
            >
              <span className="option-text">{option.text}</span>
            </div>
          ))}
        </div>

        <div className="select-icon">
          <FontAwesomeIcon
            icon={selectIcon}
            style={{
              color: selectColor,
            }}
          />
        </div>
      </div>
    </div>
  );
};
